
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/send-email-confirm",
      function () {
        return require("private-next-pages/auth/send-email-confirm.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/send-email-confirm"])
      });
    }
  